import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/collections/license.collectionOwner.claim.mutation.gql"
import type {
  ClaimCollectionOwnerMutation,
  ClaimCollectionOwnerMutationVariables,
} from "@/v2-backoffice-client/license/collections/__types__/license.collectionOwner.claim.mutation"

type Options = MutationHookOptions<
  ClaimCollectionOwnerMutation,
  ClaimCollectionOwnerMutationVariables
>

export function useClaimCollectionOwnerMutation(options?: Options) {
  return useMutation<
    ClaimCollectionOwnerMutation,
    ClaimCollectionOwnerMutationVariables
  >(mutation, options)
}
